import { styled } from "@mui/material";

interface DefaultPanelProps {
  noBorder?: boolean | null;
}

interface PullRightProps {
  deltaRight?: string | null;
}

const DefaultPanelContainer = styled("div")<DefaultPanelProps>(({ theme, noBorder }) => ({
  padding: "15px 20px",
  marginBottom: "20px",
  backgroundColor: theme.palette.surfaceLight10.main,
  border: noBorder === true ? "none" : `1px solid ${theme.palette.divider}`,
  borderRadius: "12px",
  boxShadow: noBorder === true ? "none" : theme.mixins.shadowSurfaceLight10,
  ...theme.applyStyles("dark", {
    boxShadow: noBorder === true ? "none" : theme.mixins.shadowSurfaceDark10,
  }),
  boxSizing: "border-box",
}));

const DefaultPanelHeader = styled("div")(({ theme }) => ({
  position: "relative",
  fontSize: "15px",
  fontWeight: 700,
  borderBottom: `1px solid ${theme.palette.surfaceLight40.main}`,
  padding: "10px 0px 18px 0px",
  textTransform: "uppercase",
  borderTopLeftRadius: "3px",
  borderTopRightRadius: "3px",
}));

const DefaultPanelBody = styled("div")`
  padding: 15px 0px;
  overflow: auto;
  ::-webkit-scrollbar {
    background: transparent;
  }
`;

const Container = styled("div")`
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 500px;
  justify-content: flex-start;
  width: 100%;
`;

const PullRight = styled("div")<PullRightProps>`
  position: absolute;
  right: ${(props) => (props.deltaRight ? `${props.deltaRight}px` : "0")};
  top: 5px;
  z-index: 1;
`;

const ColLHS = styled("div")`
  display: flex;
  flex-direction: column;
  width: 350px;
  min-width: 350px;
`;

const ColRHS = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  padding-left: 20px;
`;

const PanelListDetail = { Container, ColLHS, ColRHS, PullRight };

const DefaultPanel = {
  Container: DefaultPanelContainer,
  Header: DefaultPanelHeader,
  Body: DefaultPanelBody,
};

export { DefaultPanel, PanelListDetail };
